<template>
  <div class="form__field">
    <div class="form__title" v-show="field.title">{{ field.title }}</div>
    <div class="form__spacer" v-show="field.title"></div>
    <label class="form__label" v-show="field.label" :for="identifier">
      {{ field.label }}
    </label>
    <div class="form__field__group">
      <div
        class="form__control"
        v-for="option in field.options"
        :key="field.name + '-' + option.value"
      >
        <input
          type="radio"
          v-model="value"
          :id="identifier + '_' + option.value"
          :name="identifier"
          :value="option.value"
          :disabled="option.disabled"
        />
        <label class="form__switch" :for="identifier + '_' + option.value">
          {{ option.label }}
        </label>
      </div>
    </div>
    <div
      class="form__message form__message--spaced form__message--error"
      v-show="field.error"
    >
      {{ field.error }}
    </div>
    <div class="form__description" v-show="field.description">
      {{ field.description }}
    </div>
  </div>
</template>

<script>
import * as Components from ".";

export default {
  extends: Components.CheckoutField,
  name: "checkout-field-radio"
};
</script>
